document.addEventListener('rebuy:cart.change', (event) => {
    updateMemberDiscount(event);
    //displayDeliveryDatePicker(event);
});
document.addEventListener('rebuy:cart.show', (event) => {
    updateMemberDiscount(event);
    //displayDeliveryDatePicker(event);
});
function updateMemberDiscount(event) {
    setTimeout(() => {
        let subtotal = event.detail?.cart?.subtotal();
        let bar = document.getElementById('member_savings_bar');
        let bar_value = document.getElementById('member_savings_bar_value');
        if (bar && bar_value && !window.customer_is_member) {
            if (subtotal > 0) {
                bar_value.innerHTML = (Math.round(subtotal / 1000).toFixed(2));
                bar.style.display = 'flex';
            } else {
                bar.style.display = 'none';
            }
        }

        let freeShippingTier = Rebuy?.SmartCart.progressBar.tiers.find(tier => tier.type === 'shipping');
        if (freeShippingTier && window.customer_is_member) {
            freeShippingTier.minimum = 25;
        }
    }, 0);
}